export interface Category {
  id: string;
  name: string;
  namePt: string;
  nameDe: string;
  url: string;
  imageUrl: string;
  description: string;
  descriptionPt: string;
  descriptionDe: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    namePt: 'Tênis',
    nameDe: 'Schuhe',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneaker%20photographed%20against%20a%20warm%20coral%20orange%20studio%20backdrop%20with%20soft%20diffused%20lighting%2C%20floating%20composition%2C%20vibrant%20modern%20e-commerce%20product%20photography%2C%20crisp%20detail%2C%20high%20contrast%20color%20pop&width=600&height=600&seq=cat-shoes-02&orientation=squarish&nocache=true',
    description: 'Explore curated sneaker and shoe selections from various sources.',
    descriptionPt: 'Explore seleções de tênis e sapatos de várias fontes.',
    descriptionDe: 'Entdecken Sie kuratierte Sneaker- und Schuhkollektionen.',
  },
  {
    id: 'hoodies',
    name: 'Hoodies / Sweaters',
    namePt: 'Moletom / Suéter',
    nameDe: 'Hoodies / Pullover',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20navy%20blue%20hoodie%20neatly%20folded%20on%20a%20mustard%20yellow%20background%20with%20soft%20directional%20studio%20lighting%2C%20minimal%20styling%2C%20contemporary%20fashion%20catalog%20photography%2C%20rich%20color%20contrast&width=600&height=600&seq=cat-hoodies-02&orientation=squarish&nocache=true',
    description: 'Comfortable hoodies and sweaters for everyday style.',
    descriptionPt: 'Moletons e suéter confortáveis para o estilo do dia a dia.',
    descriptionDe: 'Bequeme Hoodies und Pullover für Alltagsstil.',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    namePt: 'Camisetas',
    nameDe: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Black%20graphic%20t-shirt%20with%20minimal%20print%20laid%20flat%20on%20a%20mint%20green%20pastel%20background%2C%20soft%20even%20lighting%2C%20clean%20modern%20streetwear%20product%20shot%2C%20fresh%20youthful%20aesthetic&width=600&height=600&seq=cat-tshirts-02&orientation=squarish&nocache=true',
    description: 'Essential t-shirts and graphic tees for your wardrobe.',
    descriptionPt: 'Camisetas essenciais e camisetas gráficas para seu guarda-roupa.',
    descriptionDe: 'Essenzielle T-Shirts und grafische Tees für Ihren Kleiderschrank.',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    namePt: 'Jaquetas',
    nameDe: 'Jacken',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20brown%20leather%20biker%20jacket%20displayed%20on%20a%20sage%20green%20textured%20wall%20backdrop%2C%20warm%20dramatic%20studio%20lighting%2C%20editorial%20outerwear%20photography%2C%20rich%20tones&width=600&height=600&seq=cat-jackets-02&orientation=squarish&nocache=true',
    description: 'Stylish jackets and outerwear for all seasons.',
    descriptionPt: 'Jaquetas estilosas e roupas de frio para todas as estações.',
    descriptionDe: 'Stilvolle Jacken und Outerwear für alle Jahreszeiten.',
  },
  {
    id: 'pants',
    name: 'Pants / Shorts',
    namePt: 'Calças / Shorts',
    nameDe: 'Hosen / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20indigo%20denim%20jeans%20folded%20on%20a%20blush%20pink%20seamless%20background%2C%20soft%20natural%20lighting%2C%20minimal%20fashion%20e-commerce%20photography%2C%20clean%20crisp%20presentation&width=600&height=600&seq=cat-pants-02&orientation=squarish&nocache=true',
    description: 'Premium pants and shorts for any occasion.',
    descriptionPt: 'Calças premium e shorts para qualquer ocasião.',
    descriptionDe: 'Premium-Hosen und Shorts für jede Gelegenheit.',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    namePt: 'Chapéus / Bonés',
    nameDe: 'Kopfbedeckungen',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Red%20baseball%20cap%20on%20a%20warm%20cream%20concrete%20surface%2C%20soft%20window%20light%2C%20minimal%20product%20photography%2C%20single%20accent%20color%2C%20clean%20composition&width=600&height=600&seq=cat-headwear-02&orientation=squarish&nocache=true',
    description: 'Caps, hats, and beanies for everyday wear.',
    descriptionPt: 'Bonés, chapéus e gorros para o dia a dia.',
    descriptionDe: 'Caps, Hüte und Beanies für den Alltag.',
  },
  {
    id: 'sets',
    name: 'Sets',
    namePt: 'Conjuntos',
    nameDe: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Matching%20grey%20sweatsuit%20tracksuit%20set%20arranged%20on%20a%20soft%20stone%20grey%20backdrop%2C%20even%20studio%20lighting%2C%20modern%20athleisure%20catalog%20photography%2C%20minimal%20styling&width=600&height=600&seq=cat-sets-02&orientation=squarish&nocache=true',
    description: 'Complete matching sets for effortless style.',
    descriptionPt: 'Conjuntos completos para um estilo sem esforço.',
    descriptionDe: 'Komplette passende Sets für mühelosen Stil.',
  },
  {
    id: 'underwear',
    name: 'Underwear',
    namePt: 'Underwear',
    nameDe: 'Unterwäsche',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=White%20cotton%20underwear%20essentials%20folded%20on%20a%20soft%20peach%20background%2C%20bright%20airy%20lighting%2C%20clean%20minimal%20intimates%20product%20photography&width=600&height=600&seq=cat-underwear-02&orientation=squarish&nocache=true',
    description: 'Quality underwear and essentials.',
    descriptionPt: 'Underwear de qualidade e essenciais.',
    descriptionDe: 'Qualitätsunterwäsche und Essentials.',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    namePt: 'Camisas de Time',
    nameDe: 'Trikots',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Green%20and%20white%20football%20soccer%20jersey%20on%20a%20neutral%20grey%20background%2C%20sporty%20editorial%20product%20photography%2C%20crisp%20details%2C%20stadium-inspired%20aesthetic&width=600&height=600&seq=cat-jersey-02&orientation=squarish&nocache=true',
    description: 'Sports jerseys and athletic wear.',
    descriptionPt: 'Camisas de time e roupas esportivas.',
    descriptionDe: 'Sporttrikots und Sportbekleidung.',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    namePt: 'Acessórios',
    nameDe: 'Accessoires',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20gold%20wristwatch%20and%20sunglasses%20on%20a%20deep%20charcoal%20dark%20background%2C%20dramatic%20spotlight%2C%20premium%20accessories%20product%20photography%2C%20elegant%20reflections&width=600&height=600&seq=cat-accessories-02&orientation=squarish&nocache=true',
    description: 'Watches, sunglasses, and everyday accessories.',
    descriptionPt: 'Relógios, óculos de sol e acessórios do dia a dia.',
    descriptionDe: 'Uhren, Sonnenbrillen und Alltagsaccessoires.',
  },
  {
    id: 'bags',
    name: 'Bags',
    namePt: 'Bolsas',
    nameDe: 'Taschen',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Structured%20tan%20leather%20handbag%20on%20a%20warm%20terracotta%20background%2C%20soft%20studio%20lighting%2C%20luxury%20fashion%20product%20photography%2C%20elegant%20minimal%20styling&width=600&height=600&seq=cat-bags-02&orientation=squarish&nocache=true',
    description: 'Premium bags, backpacks, and luggage.',
    descriptionPt: 'Bolsas premium, mochilas e malas.',
    descriptionDe: 'Premium-Taschen, Rucksäcke und Gepäck.',
  },
  {
    id: 'belts',
    name: 'Belts',
    namePt: 'Cintos',
    nameDe: 'Gürtel',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Coiled%20dark%20brown%20leather%20belt%20with%20brass%20buckle%20on%20a%20soft%20ivory%20background%2C%20warm%20lighting%2C%20classic%20leather%20goods%20product%20photography&width=600&height=600&seq=cat-belts-02&orientation=squarish&nocache=true',
    description: 'Designer belts and leather goods.',
    descriptionPt: 'Cintos de designer e artigos de couro.',
    descriptionDe: 'Designergürtel und Lederwaren.',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    namePt: 'Perfumes',
    nameDe: 'Parfums',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20on%20a%20soft%20rose%20pink%20silk%20fabric%20background%2C%20elegant%20lighting%2C%20luxury%20fragrance%20product%20photography%2C%20warm%20golden%20tones&width=600&height=600&seq=cat-perfumes-02&orientation=squarish&nocache=true',
    description: 'Fragrances and luxury perfumes.',
    descriptionPt: 'Fragrâncias e perfumes de luxo.',
    descriptionDe: 'Düfte und Luxusparfums.',
  },
  {
    id: 'other',
    name: 'Other Stuff',
    namePt: 'Outros Produtos',
    nameDe: 'Sonstiges',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl: 'https://readdy.ai/api/search-image?query=Assorted%20fashion%20accessories%20flat%20lay%20including%20wallet%20cap%20and%20scarf%20on%20a%20soft%20neutral%20grey%20background%2C%20organized%20overhead%20composition%2C%20editorial%20product%20photography&width=600&height=600&seq=cat-other-02&orientation=squarish&nocache=true',
    description: 'Miscellaneous items and unique finds.',
    descriptionPt: 'Itens diversos e achados únicos.',
    descriptionDe: 'Verschiedene Artikel und einzigartige Funde.',
  },
];

export const mainSiteUrl = 'https://kaspreadsheet.com';